import { default as accountIWnKuvcAuMMeta } from "/app/pages/account.vue?macro=true";
import { default as _91spaceid_93jw63XISOSaMeta } from "/app/pages/admin-photo/[spaceid].vue?macro=true";
import { default as _91spaceid_93g2Up8LroP0Meta } from "/app/pages/admin-space/[spaceid].vue?macro=true";
import { default as _91adminID_93mlTBb7cJAEMeta } from "/app/pages/admin/[adminID].vue?macro=true";
import { default as _91id_93AtkXnaxz9hMeta } from "/app/pages/banner/[id].vue?macro=true";
import { default as _91slug_93cdf2dv6FbPMeta } from "/app/pages/blog/[slug].vue?macro=true";
import { default as indexgWaMlevJ7RMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as favoritesYMtsvzhBvNMeta } from "/app/pages/favorites.vue?macro=true";
import { default as forgotNziWY5IfaeMeta } from "/app/pages/forgot.vue?macro=true";
import { default as google_45returnWQfBxtF8ZbMeta } from "/app/pages/google-return.vue?macro=true";
import { default as plan3rmTvwUwhuMeta } from "/app/pages/host/plan.vue?macro=true";
import { default as qa8XZh4CdNidMeta } from "/app/pages/host/qa.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as _91id_93viqXDfNMlNMeta } from "/app/pages/inquiries/[id].vue?macro=true";
import { default as indexnCWeVsHQN1Meta } from "/app/pages/inquiries/index.vue?macro=true";
import { default as line_45bindU9bsedqTcIMeta } from "/app/pages/line-bind.vue?macro=true";
import { default as _91_46_46_46slug_93uTXa1JTEVdMeta } from "/app/pages/list/[...slug].vue?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as _91adminID_93PvSwzcRqWrMeta } from "/app/pages/new-admin/[adminID].vue?macro=true";
import { default as new_45loginEhj2waQwtGMeta } from "/app/pages/new-login.vue?macro=true";
import { default as new_45phone_45validationFwQBtQlCi7Meta } from "/app/pages/new-phone-validation.vue?macro=true";
import { default as new_45register8VQSJNsMTSMeta } from "/app/pages/new-register.vue?macro=true";
import { default as no_45use_45meeting_45roomhCKybcRT8IMeta } from "/app/pages/no-use-meeting-room.vue?macro=true";
import { default as completed6OMJkDb4CAMeta } from "/app/pages/order/completed.vue?macro=true";
import { default as in_45progressBh0uANlANsMeta } from "/app/pages/order/in-progress.vue?macro=true";
import { default as indexCICQ7TchH0Meta } from "/app/pages/order/index.vue?macro=true";
import { default as not_45startwm8DF5bTboMeta } from "/app/pages/order/not-start.vue?macro=true";
import { default as pendingpXoSqkpyR7Meta } from "/app/pages/order/pending.vue?macro=true";
import { default as refundedYhLC3eonI7Meta } from "/app/pages/order/refunded.vue?macro=true";
import { default as orderBjfxujOe1OMeta } from "/app/pages/order.vue?macro=true";
import { default as phone_45validationbhszKfgAV0Meta } from "/app/pages/phone-validation.vue?macro=true";
import { default as owner_45servicetCocp5jdUvMeta } from "/app/pages/policies/owner-service.vue?macro=true";
import { default as privacybuTHLA3lRDMeta } from "/app/pages/policies/privacy.vue?macro=true";
import { default as registermu8R7rSP5uMeta } from "/app/pages/register.vue?macro=true";
import { default as reserve_45returnfcYoM7v0ewMeta } from "/app/pages/reserve-return.vue?macro=true";
import { default as reserverdds3adYbRMeta } from "/app/pages/reserve.vue?macro=true";
import { default as _91spaceid_9397lcnsYXbNMeta } from "/app/pages/sass-space/[spaceid].vue?macro=true";
import { default as search_45resultBWlOF1JFdGMeta } from "/app/pages/search-result.vue?macro=true";
import { default as _91spaceid_93C9GxVfKNqkMeta } from "/app/pages/space/[spaceid].vue?macro=true";
import { default as quoteIYZN8Mhf8pMeta } from "/app/pages/vendor/inquiries/quote.vue?macro=true";
import { default as reply1W5tuPzjiwMeta } from "/app/pages/vendor/inquiries/reply.vue?macro=true";
import { default as line_45bindgvaVuWT8FQMeta } from "/app/pages/vendor/line-bind.vue?macro=true";
import { default as component_45stubX6U9umRaCAMeta } from "/app/node_modules/.pnpm/nuxt@3.12.2_@opentelemetry+api@1.9.0_@parcel+watcher@2.4.1_@types+node@20.19.43_encoding@0.1._6sxuxzbnewi7guzyd2p3muotpa/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubX6U9umRaCA } from "/app/node_modules/.pnpm/nuxt@3.12.2_@opentelemetry+api@1.9.0_@parcel+watcher@2.4.1_@types+node@20.19.43_encoding@0.1._6sxuxzbnewi7guzyd2p3muotpa/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "account",
    path: "/account",
    meta: accountIWnKuvcAuMMeta || {},
    component: () => import("/app/pages/account.vue").then(m => m.default || m)
  },
  {
    name: "admin-photo-spaceid",
    path: "/admin-photo/:spaceid()",
    component: () => import("/app/pages/admin-photo/[spaceid].vue").then(m => m.default || m)
  },
  {
    name: "admin-space-spaceid",
    path: "/admin-space/:spaceid()",
    component: () => import("/app/pages/admin-space/[spaceid].vue").then(m => m.default || m)
  },
  {
    name: "admin-adminID",
    path: "/admin/:adminID()",
    component: () => import("/app/pages/admin/[adminID].vue").then(m => m.default || m)
  },
  {
    name: "banner-id",
    path: "/banner/:id()",
    component: () => import("/app/pages/banner/[id].vue").then(m => m.default || m)
  },
  {
    name: "article-detail",
    path: "/blog/:slug()",
    meta: _91slug_93cdf2dv6FbPMeta || {},
    component: () => import("/app/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexgWaMlevJ7RMeta || {},
    component: () => import("/app/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => import("/app/pages/favorites.vue").then(m => m.default || m)
  },
  {
    name: "forgot",
    path: "/forgot",
    meta: forgotNziWY5IfaeMeta || {},
    component: () => import("/app/pages/forgot.vue").then(m => m.default || m)
  },
  {
    name: "google-return",
    path: "/google-return",
    component: () => import("/app/pages/google-return.vue").then(m => m.default || m)
  },
  {
    name: "host-plan",
    path: "/host/plan",
    meta: plan3rmTvwUwhuMeta || {},
    component: () => import("/app/pages/host/plan.vue").then(m => m.default || m)
  },
  {
    name: "host-qa",
    path: "/host/qa",
    meta: qa8XZh4CdNidMeta || {},
    component: () => import("/app/pages/host/qa.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "inquiries-id",
    path: "/inquiries/:id()",
    component: () => import("/app/pages/inquiries/[id].vue").then(m => m.default || m)
  },
  {
    name: "inquiries",
    path: "/inquiries",
    meta: indexnCWeVsHQN1Meta || {},
    component: () => import("/app/pages/inquiries/index.vue").then(m => m.default || m)
  },
  {
    name: "line-bind",
    path: "/line-bind",
    component: () => import("/app/pages/line-bind.vue").then(m => m.default || m)
  },
  {
    name: "list-slug",
    path: "/list/:slug(.*)*",
    meta: _91_46_46_46slug_93uTXa1JTEVdMeta || {},
    component: () => import("/app/pages/list/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: loginhHM0vSTW5jMeta || {},
    component: () => import("/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "new-admin-adminID",
    path: "/new-admin/:adminID()",
    component: () => import("/app/pages/new-admin/[adminID].vue").then(m => m.default || m)
  },
  {
    name: "new-login",
    path: "/new-login",
    meta: new_45loginEhj2waQwtGMeta || {},
    component: () => import("/app/pages/new-login.vue").then(m => m.default || m)
  },
  {
    name: "new-phone-validation",
    path: "/new-phone-validation",
    meta: new_45phone_45validationFwQBtQlCi7Meta || {},
    component: () => import("/app/pages/new-phone-validation.vue").then(m => m.default || m)
  },
  {
    name: "new-register",
    path: "/new-register",
    meta: new_45register8VQSJNsMTSMeta || {},
    component: () => import("/app/pages/new-register.vue").then(m => m.default || m)
  },
  {
    name: "no-use-meeting-room",
    path: "/no-use-meeting-room",
    meta: no_45use_45meeting_45roomhCKybcRT8IMeta || {},
    component: () => import("/app/pages/no-use-meeting-room.vue").then(m => m.default || m)
  },
  {
    name: orderBjfxujOe1OMeta?.name,
    path: "/order",
    meta: orderBjfxujOe1OMeta || {},
    component: () => import("/app/pages/order.vue").then(m => m.default || m),
    children: [
  {
    name: "order-completed",
    path: "completed",
    meta: completed6OMJkDb4CAMeta || {},
    component: () => import("/app/pages/order/completed.vue").then(m => m.default || m)
  },
  {
    name: "order-in-progress",
    path: "in-progress",
    meta: in_45progressBh0uANlANsMeta || {},
    component: () => import("/app/pages/order/in-progress.vue").then(m => m.default || m)
  },
  {
    name: "order",
    path: "",
    component: () => import("/app/pages/order/index.vue").then(m => m.default || m)
  },
  {
    name: "order-not-start",
    path: "not-start",
    meta: not_45startwm8DF5bTboMeta || {},
    component: () => import("/app/pages/order/not-start.vue").then(m => m.default || m)
  },
  {
    name: "order-pending",
    path: "pending",
    meta: pendingpXoSqkpyR7Meta || {},
    component: () => import("/app/pages/order/pending.vue").then(m => m.default || m)
  },
  {
    name: "order-refunded",
    path: "refunded",
    meta: refundedYhLC3eonI7Meta || {},
    component: () => import("/app/pages/order/refunded.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "phone-validation",
    path: "/phone-validation",
    meta: phone_45validationbhszKfgAV0Meta || {},
    component: () => import("/app/pages/phone-validation.vue").then(m => m.default || m)
  },
  {
    name: "policies-owner-service",
    path: "/policies/owner-service",
    meta: owner_45servicetCocp5jdUvMeta || {},
    component: () => import("/app/pages/policies/owner-service.vue").then(m => m.default || m)
  },
  {
    name: "policies-privacy",
    path: "/policies/privacy",
    meta: privacybuTHLA3lRDMeta || {},
    component: () => import("/app/pages/policies/privacy.vue").then(m => m.default || m)
  },
  {
    name: "register",
    path: "/register",
    meta: registermu8R7rSP5uMeta || {},
    component: () => import("/app/pages/register.vue").then(m => m.default || m)
  },
  {
    name: "reserve-return",
    path: "/reserve-return",
    meta: reserve_45returnfcYoM7v0ewMeta || {},
    component: () => import("/app/pages/reserve-return.vue").then(m => m.default || m)
  },
  {
    name: "reserve",
    path: "/reserve",
    meta: reserverdds3adYbRMeta || {},
    component: () => import("/app/pages/reserve.vue").then(m => m.default || m)
  },
  {
    name: "sass-space-spaceid",
    path: "/sass-space/:spaceid()",
    component: () => import("/app/pages/sass-space/[spaceid].vue").then(m => m.default || m)
  },
  {
    name: "search-result",
    path: "/search-result",
    meta: search_45resultBWlOF1JFdGMeta || {},
    component: () => import("/app/pages/search-result.vue").then(m => m.default || m)
  },
  {
    name: "space-detail",
    path: "/space/:spaceid()",
    meta: _91spaceid_93C9GxVfKNqkMeta || {},
    component: () => import("/app/pages/space/[spaceid].vue").then(m => m.default || m)
  },
  {
    name: "vendor-inquiries-quote",
    path: "/vendor/inquiries/quote",
    component: () => import("/app/pages/vendor/inquiries/quote.vue").then(m => m.default || m)
  },
  {
    name: "vendor-inquiries-reply",
    path: "/vendor/inquiries/reply",
    component: () => import("/app/pages/vendor/inquiries/reply.vue").then(m => m.default || m)
  },
  {
    name: "vendor-line-bind",
    path: "/vendor/line-bind",
    component: () => import("/app/pages/vendor/line-bind.vue").then(m => m.default || m)
  },
  {
    name: component_45stubX6U9umRaCAMeta?.name,
    path: "/host/homepage",
    component: component_45stubX6U9umRaCA
  }
]